import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'; import qs from 'qs'
import clone from 'lodash.clone'
import merge from 'lodash.merge'

import helpers from './../helpers.js'

import createLogger from 'vuex/dist/logger'
import createPersistedState from 'vuex-persistedstate'


Vue.use(Vuex)

//import helpers from './../helpers.js'

//import module from './modules/module.js'

//------------------------------------------------------------------------------

const logger = createLogger({
  collapsed: false, // auto-expand logged mutations
  filter (mutation, stateBefore, stateAfter) {
    return mutation.type !== "aBlacklistedMutation"
  },
  transformer (state) {
    // transform the state before logging it.
    // for example return only a specific sub-tree
    return state.subTree
  },
  mutationTransformer (mutation) {
    return mutation.type
  },
  logger: console,
})

//------------------------------------------------------------------------------

const store = new Vuex.Store({
  strict: false, // In strict mode, whenever Vuex state is mutated outside of mutation handlers, an error will be thrown
  plugins: [ 
    createPersistedState({ // persist vuex to localstorage, so mainly login is kept
      paths: [
        'loggedin_user',
        'casting_active_index',
        'castings',
        //'my_casting_uids',
        //'my_casting_active_uid',
      ],
    }), 
    //createLogger()  // console.log out all mutations with metadata
  ], 
  modules: {
    //module,
  },
  state: {
  
  //-----------------------------------------------------------------------------

    domain: undefined,

    small_spinner: false,
    big_spinner: false,

    imgs_fetched: [],

    show_beta_content: false,
    off_canvas_menu_active: false,  
    
    base_url: 'https://scoopmodels.com/',
    api_url: 'https://scoopmodels.com/api/',

    base_url_am: 'https://a-management.eu/',

    route: {
      current: undefined,
      previous: [],
    },

    is_fetching_content: false,
    is_site_while_fetching_content: undefined,

    metrics: 'eu',

    admin_fetched_content: {
      pages: undefined, page: undefined,
      models: undefined, model: undefined,
      artists: undefined, artist: undefined,      
      settings: undefined,
      trashed: undefined,
    },

    editing_blocks: false,

    loggedin_user: undefined,

    loaded_model: undefined,
    loaded_artist: undefined,
    
    loaded_influencers: undefined,
    loaded_influencer: undefined,    

    loaded_page: undefined,
    loaded_blocks: undefined,

    leftbar_main_toggled_open: {},

    leftmenu: {
      is:'global',
    },

    findbox: {
      open: false,
      models_found: [],
    },

    model_eye_color_options: undefined,
    model_hair_color_options: undefined,
    
    model_names: undefined,

    modal: {      
      media_lib: { open:false, model_id:undefined, artist_id:undefined, influencer_id:undefined, },
      media_preview: { open:false, media:undefined, },
      media_info: { open:false, medias:undefined, },
      media_crop: { open:false, media:undefined, },
      media_tweak: { open:false, media:undefined, },      
      media_upload: { open:false, model_id:undefined, artist_id:undefined, influencer_id:undefined, },
      media_upload_video: { open:false, model_id:undefined, artist_id:undefined, influencer_id:undefined, },
      media_edit_links: { open:false },
      model_book_thumb: { open:false, model:undefined, media_id:undefined, },
      video_player: { open:false, media:undefined, },
      model_options: { open:false, },
      am_add_casting_by_artist: { open:false, },
    },

    admin: {
      medialib: {
        active_folder_id: undefined,
        on_media_select: undefined,
        media_max_upload_mb_size: 4,
        showing: [ 'all', 'models_media', 'artists_media', 'influencers_media', 'contentpages', 'newsarticles', 'artistgalleries' ],        
        multiselection_enabled: true,
      },
    },

    my_casting_uids: [],
    my_casting_active_uid: undefined,
    my_castings_validated: undefined,

    my_castings: undefined,

    casting_active_index: 0,
    castings: [],

    casting_empty_template: {
      title: 'New package',
      notes: '',
      to_name: '',
      to_email: '',
      from_name: '',
      from_email: '',
      items: [],
    },


    quill_default_options: {
			modules: {
				toolbar: {
					container: [
            //[ { 'header':1 }, { 'header':2 } ],
            { header: [1,2,3,false] },
            { list: 'ordered' },
            { list: 'bullet' },
            { align: [] },
            'bold',
            'italic',
            //'image',
            'link',	
            'clean',				
          ],
          handlers: {},          
        },        
			},
    },

    blocks_max: {
      model: {
        portfolio: 20,
        runway: 20,
        polaroids: 4,
      },
    },


    generic_field_editor: {
      active: false,
      field_type: undefined,
      label: undefined,
      value: undefined,
      min: undefined,
      max: undefined,
      step: undefined,
      onSave: undefined,
    },

    loaded_catalog: undefined,
    
    frontpage_content: undefined,

    cms_settings: undefined,
    

    msgs: [],

    logo_pre_html: undefined,
		

//-----------------------------------------------------------------------------

  },// state
  getters: {

//-----------------------------------------------------------------------------

  is_local( state,getters ){
    var d = state.domain
              .replace('http://','')
              .replace('https://','')
              .replace('www.','')
              .replace('/','')              
    if( d == 'scoopmodels.com' ) return false
    return true
  },

  is_live( state, getters ){
    return !getters.is_local
  },

//-----------------------------------------------------------------------------

  is_site_am(state,getters) {
    if( window.is_site_am == true ) return true
    return false
  },

//-----------------------------------------------------------------------------

  is_site_scoop(state,getters) {
    return !getters.is_site_am
  },

//-----------------------------------------------------------------------------

  is_site_scoopsocial(state,getters) {
    if( getters.is_site_am ) return false
    var r = state.route.current
    if( !r ) return false

    var rt = ( r.meta && r.meta.tags ) || {}

    //console.log(r)
    if( state.is_fetching_content && state.is_site_while_fetching_content == 'scoopsocial' ) return true

    if( r.path == '/social' ) return true
    if( r.path == '/social/news' ) return true
    if( r.path == '/social/contact' ) return true
    if( r.path == '/social/about' ) return true
    if( r.path == '/social/location' ) return true
    
    if( rt.influencers_list ) return true
    if( rt.influencer_single ) return true

    if( state.loaded_page && state.loaded_page.realm && state.loaded_page.realm == 'scoopsocial' ) return true
    
    return false
  },

//-----------------------------------------------------------------------------  

  is_site( state, getters ){
    if( getters.is_site_scoopsocial ) return 'scoopsocial'
    if( getters.is_site_am ) return 'amanagement'
    return 'scoopmodels'
  },

//-----------------------------------------------------------------------------

  is_milk(state,getters){ 
    return ( state.loggedin_user && state.loggedin_user.email == 'hello@milk-studio.dk' ) 
  },

//-----------------------------------------------------------------------------

  pageslug(state){
    if( !state.route || !state.route.current || !state.route.current.path ) return
    let slug = state.route.current.path
    while(slug.charAt(0) === '/') slug = slug.substr(1)
    return slug
  },


//-----------------------------------------------------------------------------

    getById: (state,getters) => ( type, id ) => 
    {
        if( !state.db ) return
        var items = state.db[type+'s']
        if( !items ) return

        for( var i = 0; i < items.length; i++ ) {
          var item = items[i]
          if( item.id === id ) return item
        }
    },

//-----------------------------------------------------------------------------

    active_casting(state,getters){

      if( !state.castings ) return
      if( !state.castings.length ) return
      if( state.casting_active_index == undefined ) return
      if( !state.castings[ state.casting_active_index ] ) return

      return state.castings[ state.casting_active_index ]

    },

//-----------------------------------------------------------------------------

  medialib_active_folder_model_id(state,getters){
    
    var active_folder_id = state.admin.medialib.active_folder_id
    if( active_folder_id == undefined ) return
    var model_id = active_folder_id - 6000000 // dynamic folder id appendix
    if( model_id < 0 ) return
    return model_id
  },

//-----------------------------------------------------------------------------

  },// getters
  mutations: {

//-----------------------------------------------------------------------------
  
  set_small_spinner(state,boolean){ state.small_spinner = boolean },
  set_big_spinner(state,boolean){ state.big_spinner = boolean },

  set_leftmenu_is(state,value){ state.leftmenu.is = value },

  set_domain( state, domain ){
    state.domain = domain
  },

  set_is_site_while_fetching_content( state, value ){
    state.is_site_while_fetching_content = value
  },

  set__cms_settings( state, data ){ state.cms_settings = data },
  set__frontpage_content( state, data ){ state.frontpage_content = data },

//-----------------------------------------------------------------------------

  push_msg( state,msg ){
    state.msgs.push(msg)
  },

  kill_msg( state ){
    state.msgs.pop()
  },

//-----------------------------------------------------------------------------

  set_off_canvas_menu_active(state,bool){
    state.off_canvas_menu_active = bool
    document.body.classList.toggle( 'offmenu-active', bool )    
  },

//-----------------------------------------------------------------------------

    onRouteChange(state, data){
      var to = clone(data.to)
      var from = clone(data.from)
      delete to['matched']; delete from['matched'] // too much unneccesary component data in it

      to.parts = to.path.split('/')
      from.parts = to.path.split('/')

      Vue.set( state.route, 'current', to )
      state.route.previous.unshift(from)
      state.route.previous = state.route.previous.slice(0,20) // keep only last 5 routes so it doesn't fill up too much
      Vue.set( state.route, 'previous', state.route.previous )

      if( state.off_canvas_menu_active ) state.off_canvas_menu_active = false

    },

//-----------------------------------------------------------------------------

    leftbar_main_toggle_open(state,p){
      if( state.leftbar_main_toggled_open[ p.lvl ] == undefined ) {
        Vue.set( state.leftbar_main_toggled_open, p.lvl, {} )
      }      
      Vue.set( state.leftbar_main_toggled_open[ p.lvl ], p.key, p.toggled )
    },

//-----------------------------------------------------------------------------

    setMetrics(state, metrics){
      state.metrics = metrics
    },

    set__logo_pre_html(state,html){ state.logo_pre_html = html },
    
//-----------------------------------------------------------------------------    

    toggle_show_beta_content(state,input){
      if( input == undefined ) input = !state.show_beta_content
      state.show_beta_content = input
    },

//-----------------------------------------------------------------------------

  set__generic_field_editor( state, input ){
    for( let key in input ) state.generic_field_editor[key] = input[key]
  },

//-----------------------------------------------------------------------------

    modal_open(state, input ) {
      
      if( !state.modal[ input.modal ] ) return

      state.modal[ input.modal ].open = true

      if( input.modal == 'media_lib' ) {
        if(input.active_folder_id !== undefined) state.admin.medialib.active_folder_id = input.active_folder_id
        if(input.multiselection_enabled !== undefined) state.admin.medialib.multiselection_enabled = input.multiselection_enabled
      }
      
      if( input.modal == 'media_info' ) {
        state.modal[ input.modal ].medias = input.medias
      }

      if( input.modal == 'media_preview' ) {
        state.modal[ input.modal ].media = input.media        
      }

      if( input.modal == 'media_crop' ) {
        state.modal[ input.modal ].media = input.media
      }

      if( input.modal == 'media_tweak' ) {
        state.modal[ input.modal ].media = input.media
      }
      
      if( input.modal == 'media_edit_links' ) {
        state.modal[ input.modal ].media = input.media
      }

      if( input.modal == 'media_upload' ) {
        state.modal[ input.modal ].model_id = input.model_id
        state.modal[ input.modal ].artist_id = input.artist_id
        state.modal[ input.modal ].influencer_id = input.influencer_id
      }
      
      if( input.modal == 'media_upload_video' ) {
        state.modal[ input.modal ].model_id = input.model_id
        state.modal[ input.modal ].artist_id = input.artist_id
        state.modal[ input.modal ].influencer_id = input.influencer_id
      }

      if( input.modal == 'model_book_thumb' ) {
        state.modal[ input.modal ].model = input.model
        state.modal[ input.modal ].media_id = input.media_id
      }

      if( input.modal == 'video_player' ) {
        state.modal[ input.modal ].media = input.media
      }
      
      if( input.modal == 'am_add_casting_by_artist' ) {
        state.modal[ input.modal ].media = input.media
      }

      
    },

    modal_close(state, modal){ state.modal[modal].open = false },

    set_loaded_model( state, model ){
      Vue.set( state, 'loaded_model', model )
    },

    set_loaded_artist( state, artist ){
      Vue.set( state, 'loaded_artist', artist )
    },

    set_loaded_influencer( state, influencer ){
      Vue.set( state, 'loaded_influencer', influencer )
    },

    set_loaded_influencers( state, influencers ){
      Vue.set( state, 'loaded_influencers', influencers )
    },

    set_loaded_page(state,input){
      Vue.set( state, 'loaded_page', input )
    },

    set_loaded_blocks(state,input){
      Vue.set( state, 'loaded_blocks', input )
    },

    set_is_fetching_content(state,boolean){
      Vue.set( state, 'is_fetching_content', boolean )
    },

    set_loggedin_user(state,user){
      Vue.set( state, 'loggedin_user', user )
    },

//------------------------------------------------------------------------------

    findbox_open(state){ state.findbox.open = true  /* and input? :) */},

    findbox_close(state){ state.findbox.open = false },


    set_findbox_models_found(state,data){ state.findbox.models_found = data },

//------------------------------------------------------------------------------

    set_admin_fetched_content(state,input){

      if( !state.admin_fetched_content ) Vue.set( state, 'admin_fetched_content', {} )

      Vue.set( state.admin_fetched_content, input.type, input.result )

    },

    set_editing_blocks(state, boolean){ state.editing_blocks = boolean },

    set_admin_medialib_on_media_select( state, fn ){
      state.admin.medialib.on_media_select = fn
    },

    //add_img_fetched( state, img_src ){
    //  state.imgs_fetched.push(img_src)
    //},

    set_medialib_visibles(state,data){
      state.admin.medialib.visibles = data
    },

    set_admin_medialib_active_folder_id(state,data){
      state.admin.medialib.active_folder_id = data
    },

//-----------------------------------------------------------------------------    

  set_loaded_catalog(state,data){ state.loaded_catalog = data },

//-----------------------------------------------------------------------------    

  set__model_eye_color_options(state,data){ state.model_eye_color_options = data; },
  set__model_hair_color_options(state,data){ state.model_hair_color_options = data; },
  set__get_model_names(state,data){ state.model_names = data; },

//-----------------------------------------------------------------------------    

  set__my_castings(state,data){ state.my_castings = data },

  //alternative setup, remove all below if not needed
  set__my_casting_active_uid(state,uid){ state.my_casting_active_uid = uid },
  set__my_casting_uids(state,uids){ state.my_casting_uids = uids },
  set__my_castings_validated(state,castings){ state.my_castings_validated = castings },

  my_casting_uids_add(state,uid){
    if( state.my_casting_uids.indexOf(uid) !== -1 ) return
    state.my_casting_uids.push(uid)
  },

  my_casting_uids_remove(state,uid){
    var i = state.my_casting_uids.indexOf(uid)
    if( i === -1 ) return
    state.my_casting_uids.splice(i,1)    
  },
  //alternative setup, remove all above if not needed

//-----------------------------------------------------------------------------    

  //old setup, remove all below if not needed

    casting_item_add(state, item ) {
      
      var casting = state.castings[state.casting_active_index]
      if( !casting ) return
      let items = casting.items

      state.castings[state.casting_active_index].items.push(item)
      return

      let addingIndex = -1

      if( item.model_id )       addingIndex = items.findIndex( (elem) => elem.model_id === item.model_id )
      if( item.influencer_id )  addingIndex = items.findIndex( (elem) => elem.influencer_id === item.influencer_id )
      if( item.artist_id )      addingIndex = items.findIndex( (elem) => elem.artist_id === item.artist_id )

      if( addingIndex === -1 ) {
        //console.log('appending')
        state.castings[state.casting_active_index].items.push(item)
      } else {
        //console.log('addingIndex',addingIndex)
        state.castings[state.casting_active_index].items.splice( addingIndex, 0, item )
      }

    },

//-----------------------------------------------------------------------------    

    casting_item_remove(state, item_i ) {      
      if( item_i === undefined ) return
      state.castings[state.casting_active_index].items.splice(item_i,1)
    },

//-----------------------------------------------------------------------------    

    // remove by { key, input } eg.: { 'model_id', 55 }
    casting_items_remove_all_by(state, input ) {
      var items = state.castings[state.casting_active_index].items
      items = items.filter(function(item){
        if( item && item[ input.type ] && item[ input.type ] == input.id ) return false
        return true
      })
      Vue.set( state.castings[state.casting_active_index], 'items', items )
    },

//-----------------------------------------------------------------------------    

    // this should probably be an action so we can ajax?
    save_casting(state, item ) {
      state.castings.push({
        title: 'New casting',
        items: [],
        to_name: undefined,
        to_email: undefined,
        from_name: undefined,
        from_email: undefined,
        notes: undefined,      
      })
    },
    
//-----------------------------------------------------------------------------    

    create_new_empty_casting(state){      
      var casting = JSON.parse(JSON.stringify(state.casting_empty_template))
      casting.uid = helpers.generate_uid_key(5)
      state.castings.push(casting)
    },

//-----------------------------------------------------------------------------    

    delete_casting(state,index){
      state.castings.splice(index,1)
      Vue.set( state, 'castings', state.castings )
      var num = index -1
      if( num < 0 ) num = 0
      state.casting_active_index = num    },

//-----------------------------------------------------------------------------    

    update_casting(state, input ) {
      if( input.index == undefined ) return
      if( !input.patch ) return
      if( !input.index ) input.index = state.casting_active_index
      state.castings[input.index] = merge( state.castings[input.index], input.patch )      
    },

    casting_add(state,casting){
      state.castings.push(casting)
    },

//-----------------------------------------------------------------------------    

    set_casting_active_index(state,num){ state.casting_active_index = num },

    //old setup, remove all above if not needed

//-----------------------------------------------------------------------------    
  
  },// mutations
  actions: {

//-----------------------------------------------------------------------------

    load_admin_generic_items({ commit, state, dispatch }, input ) {

      commit('set_is_fetching_content',true)

      if( !input.access_token ) input.access_token = state.loggedin_user.access_token

      if( input.fetch == 'pages' )    var endpoint = 'admin_fetch_pages_all'
      if( input.fetch == 'page' )     var endpoint = 'admin_fetch_page_single'
      if( input.fetch == 'models' )   var endpoint = 'admin_fetch_models_all'
      if( input.fetch == 'model' )    var endpoint = 'admin_fetch_model_single'
      if( input.fetch == 'artists' )   var endpoint = 'admin_fetch_artists_all'
      if( input.fetch == 'artist' )    var endpoint = 'admin_fetch_artist_single'
      if( input.fetch == 'influencers' )   var endpoint = 'admin_fetch_influencers_all'
      if( input.fetch == 'influencer' )    var endpoint = 'admin_fetch_influencer_single'
      if( input.fetch == 'galleries' )   var endpoint = 'admin_fetch_galleries_all'
      if( input.fetch == 'gallery' )    var endpoint = 'admin_fetch_gallery_single'
      if( input.fetch == 'catalogs' )   var endpoint = 'admin_fetch_catalogs_all'
      if( input.fetch == 'catalog' )    var endpoint = 'admin_fetch_catalog_single'
      if( input.fetch == 'settings' )    var endpoint = 'admin_fetch_settings_all'
      if( input.fetch == 'trashed' )    var endpoint = 'admin_fetch_trashed_items'
      
      return axios.post( state.api_url + endpoint, qs.stringify(input) )
      .then(function(result){

        var output = result.data 
        
        if( output.error ) {

          if( output.error == 'no-auth' || output.error == 'invalid-access-token' ) {
            dispatch('user_logout')
            window.location.reload()
            return false

          }
        }

        commit('set_is_fetching_content',false)        
        
        commit('set_admin_fetched_content',{
          type: input.fetch,
          result: result.data.data.result,
        })

        if( input.onSuccess ) setTimeout(function(){ input.onSuccess() })

      })
      .catch(function(error){
        
        commit('set_is_fetching_content',false)
        if( input.onError ) input.onError(error)

      })

    },

//-----------------------------------------------------------------------------

    // generic action for ALL ajax calls

    fetch({ commit, state }, settings ){

      var endpoint = settings.endpoint
      var input = settings.input

      if( settings.auth ) {
        if( !state.loggedin_user || !state.loggedin_user.access_token ) {
          console.log('error - could not perform auth fetch with no logged in user')
          return
        }
        input.access_token = state.loggedin_user.access_token
      }

      if( !settings.input.skip_set_is_fetching_content ) commit( 'set_is_fetching_content', true )

      return axios.post( state.api_url + endpoint, qs.stringify(input) )
        .then(function(result){

          // supply the processed result, but also the original result
          // check if valid output

          if( !settings.input.skip_set_is_fetching_content ) commit( 'set_is_fetching_content', false )

          var output = result.data

          var trigger_auth_fail = ( output.error && settings.onAuthFail && ( output.error == 'invalid-access-token' || output.error == 'no-auth' ) )
          if( trigger_auth_fail ) { settings.onAuthFail(); return }

          if( !output || !output.status || output.status != 'success' || output.error ) {
            if( settings.onError ) settings.onError(output)
            return
          }

          if( settings.onSuccess ) settings.onSuccess( output, result )

        })
        .catch(function(error){
          
          if( !settings.input.skip_set_is_fetching_content ) commit( 'set_is_fetching_content', false )

          // look at the error, and supply an improved cleansed version of it?
          // perhaps also deliver the original error as well, just in case it might be needed sometime?

          if( settings.onError ) settings.onError(error)

        })

    },

//-----------------------------------------------------------------------------

  packages_fetch({ commit, state }, input){    
    return new Promise((resolve, reject) => {
      axios.post( state.api_url + 'packages_fetch', qs.stringify(input) )
        .then((response)=>{
          resolve(response)
        })
        .catch((response)=>{
          reject(response)
        })
    })   
  },

//-----------------------------------------------------------------------------

    user_logout({ commit, state }, input ) {      
      commit('set_loggedin_user', undefined)
      //localStorage.removeItem( 'scoop_loggedin_user' )
    }, 

//-----------------------------------------------------------------------------    

  fetch_frontpage_content({ commit, state }, input){    
    return new Promise((resolve, reject) => {
      axios.post( state.api_url + 'get_frontpage_content', qs.stringify(input) )
        .then((response)=>{
          commit('set__frontpage_content', response.data)
          resolve(response)
        })
        .catch((response)=>{
          reject(response)
        })
    })   
  },

//-----------------------------------------------------------------------------    

  settings_fetch({ commit, state }, input){    
    return new Promise((resolve, reject) => {
      axios.post( state.api_url + 'get_settings', qs.stringify(input) )
        .then((response)=>{
          commit('set__cms_settings', response.data)
          resolve(response)
        })
        .catch((response)=>{
          reject(response)
        })
    })   
  },

  update_settings({ commit, state }, input){    
    return new Promise((resolve, reject) => {
      axios.post( state.api_url + 'update_settings', qs.stringify(input) )
        .then((response)=>{
          resolve(response)
        })
        .catch((response)=>{
          reject(response)
        })
    })   
  },

//-----------------------------------------------------------------------------

  fetch_model_eye_hair_color_options({ commit, state  }, input){
    return new Promise((resolve, reject) => {
      axios.post( state.api_url + 'get_eye_hair_color_options', qs.stringify(input) )
        .then((response)=>{
          
          commit('set__model_eye_color_options', response.data.data.eye_colors)
          commit('set__model_hair_color_options', response.data.data.hair_colors )
          
          resolve(response)
        })
        .catch((response)=>{
          reject(response)
        })
    })

  },

  //-----------------------------------------------------------------------------

  fetch_model_names({ commit, state  }, input){
    return new Promise((resolve, reject) => {
      axios.post( state.api_url + 'get_casting_items_metadata', qs.stringify(input) )
        .then((response)=>{
          
          commit('set__get_model_names', response.data.data)
          
          resolve(response)
        })
        .catch((response)=>{
          reject(response)
        })
    })

  },

//-----------------------------------------------------------------------------

  // this should actually be outdated and no longer in use

  casting_items_append_metadata({ commit, state  }, items){
      
      var input = {
        items: items
      }

      return new Promise((resolve, reject) => {
        axios.post( state.api_url + 'get_casting_items_metadata', qs.stringify(input) )
          .then((response)=>{
            
            for( let item of items ) {            
              if( item.model_id ) for( let model of response.data.data.models ) if( model.id === item.model_id ) item.model = model
              if( item.artist_id ) for( let artist of response.data.data.artists ) if( artist.id === item.artist_id ) item.artist = artist
              if( item.influencer_id ) for( let influencer of response.data.data.influencers ) if( influencer.id === item.influencer_id ) item.influencer = influencer
              if( item.media_id ) for( let media of response.data.data.medias ) if( media.id === item.media_id ) item.media = media
            }

            // filter out items with no metadata
            items = items.filter(function(item){
              if( item.model_id && !item.model ) return false
              if( item.artist_id && !item.artist ) return false
              if( item.influencer_id && !item.influencer ) return false
              if( item.media_id && !item.media ) return false
              return true
            })

            resolve(items)
          })
          .catch((response)=>{
            reject(response)
          })
      })


    },

//-----------------------------------------------------------------------------

  casting_get({ commit, state  }, uid){
    return new Promise((resolve, reject) => {
      axios.post( state.api_url + 'get_casting', qs.stringify({ uid }) )
        .then((response)=>{          
          resolve(response.data.data.casting)
        })
        .catch((response)=>{
          reject(response)
        })
    })
  },

//-----------------------------------------------------------------------------

  casting_delete({ commit, state  }, casting){
    return new Promise((resolve, reject) => {
      axios.post( state.api_url + 'casting_delete', qs.stringify({ uid: casting.uid, }) )
        .then((response)=>{          
          resolve(response)
        })
        .catch((response)=>{
          reject(response)
        })
    })
  },

//-----------------------------------------------------------------------------

  casting_update({ commit, state  }, input){
    if( !input || !input.uid || !input.patch ) return
    return new Promise((resolve, reject) => {
      axios.post( state.api_url + 'casting_update', qs.stringify({ uid:input.uid, patch:input.patch }) )
        .then((response)=>{          
          resolve(response)
        })
        .catch((response)=>{
          reject(response)
        })
    })
  },

//-----------------------------------------------------------------------------

  casting_create_new({ commit, state  }){
    return new Promise((resolve, reject) => {
      axios.post( state.api_url + 'casting_create_new')
        .then((response)=>{          
          resolve(response.data.data.casting)
        })
        .catch((response)=>{
          reject(response)
        })
    })
  },

//-----------------------------------------------------------------------------
  
  validate_my_castings({ commit, state  }, uids){
    return new Promise((resolve, reject) => {
      axios.post( state.api_url + 'validate_my_castings', qs.stringify({ uids }) )
        .then((response)=>{          
          var castings = response.data.data.castings
          commit('set__my_castings_validated', castings)
          resolve(castings)
        })
        .catch((response)=>{
          reject(response)
        })
    })
  },

//-----------------------------------------------------------------------------

  get_my_castings({ commit, state  }, email){
    return new Promise((resolve, reject) => {
      axios.post( state.api_url + 'get_my_castings', qs.stringify({ email }) )
        .then((response)=>{          
          var castings = response.data.data.castings
          commit('set__my_castings', castings)
          resolve(castings)
        })
        .catch((response)=>{
          reject(response)
        })
    })
  },

//-----------------------------------------------------------------------------

  casting_items_load_metadata({ commit, state  }, items){
    return new Promise((resolve, reject) => {
      axios.post( state.api_url + 'casting_items_load_metadata', qs.stringify({ items }) )
        .then((response)=>{          
          resolve(response.data.data.items)
        })
        .catch((response)=>{
          reject(response)
        })
    })
  },

//-----------------------------------------------------------------------------

  },// actions
})

//------------------------------------------------------------------------------

// store hot reloading: https://vuex.vuejs.org/guide/hot-reload.html

if (module.hot) {
  module.hot.accept([
    //'./modules/module',      
    
  ], () => {
    store.hotUpdate({
      modules: {
        //module: require('./modules/module').default,
      },
    })
  })
}

//------------------------------------------------------------------------------

export default store


// WEBPACK FOOTER //
// ./src/store/store.js